export type BALANCE_CHANGES = {
  tokens: number;
  usd: number;
};

export enum NOTIFICATION_TYPE {
  COMMON = 'COMMON',
  BALANCE_CHANGES = 'BALANCE_CHANGES',
}
